module.exports = __webpack_public_path__ + "img/modal-logo.709869c8.png";